var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-banner', {
    staticClass: "gift-promo-banner",
    attrs: {
      "banner-id": "gift-promo",
      "show": _vm.showGiftPromoBanner,
      "height": "3rem"
    }
  }, [_c('div', {
    staticClass: "content d-flex justify-content-around align-items-center ml-auto mr-auto",
    attrs: {
      "slot": "content",
      "aria-label": _vm.$t('subscription')
    },
    on: {
      "click": _vm.showSelectUser
    },
    slot: "content"
  }, [_vm._m(0), _vm._m(1), _vm._m(2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "svg-icon svg-gifts left-gift",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.gifts)
    }
  });
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "announce-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('g1g1Announcement'))
    }
  });
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "svg-icon svg-gifts right-gift",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.gifts)
    }
  });

}]

export { render, staticRenderFns }